import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import {
  JUMP_BOX_PADDING_HORIZONTAL,
  JUMP_BOX_PADDING_HORIZONTAL_MOBILE,
  JUMP_BOX_PADDING_VERTICAL,
  JUMP_BOX_PADDING_VERTICAL_MOBILE,
  JUMP_TEXT_PROPS,
  JUMP_TEXT_PROPS_MOBILE,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/footer/helpers/footer.figma';
import { VideoPlane } from '@Components/BigBrowse/bb2/meshes2/cards/VideoPlane';
import { Html } from '@react-three/drei';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const MultiSectionFooterItem = observer(function MultiSectionFooterItem({
  item,
  onClick,
}: GridCardMeshProps<PlaneTypes.Card_MultiSection_Footer_Item>) {
  const videoData = useMemo(
    () =>
      item.data?.jumpDto.heroMedia.items.find(
        (i) => i.mediaType === 'Mp4VideoClip'
      ),
    [item]
  );

  if (videoData) {
    return (
      <VideoPlane
        position={item.worldPosition}
        size={item.size}
        src={videoData.url}
        sourceSize={{ width: videoData.width, height: videoData.height }}
      />
    );
  }

  const paddingVertical =
    item.data?.layout === 'full'
      ? JUMP_BOX_PADDING_VERTICAL
      : JUMP_BOX_PADDING_VERTICAL_MOBILE;

  const paddingHorizontal =
    item.data?.layout === 'full'
      ? JUMP_BOX_PADDING_HORIZONTAL
      : JUMP_BOX_PADDING_HORIZONTAL_MOBILE;

  const htmlStyle = {
    pointerEvents: 'none',
    width: item.size.width - paddingHorizontal * 2,
    height: item.size.height - paddingVertical * 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: 'white',
    cursor: 'default',
  };

  const titleStyle =
    item.data?.layout === 'full' ? JUMP_TEXT_PROPS : JUMP_TEXT_PROPS_MOBILE;

  return (
    <ProductCardRounded
      position={item.worldPosition}
      size={item.size.width}
      imageUrl={item.data?.imageUrl}
      transparencyColor={transparencyColors[item.type]}
      onClick={onClick}
      uniqueKey={item.key!}
    >
      {/* @ts-expect-error*/}
      <Html style={htmlStyle} center zIndexRange={[0, 0]}>
        <div style={titleStyle}>{item.data?.title}</div>
      </Html>
    </ProductCardRounded>
  );
});
